
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Luxuryresortinnagpurdistricwihforestview() {



  const cardData =
  {
    keyword: ' Luxury Resort in Nagpur District with Forest View',
    heading:  'Woodland Escape: Luxury Resort in Nagpur District with Forest View ',
    headingDescription: 'Woodland Escape Resort in Nagpur District invites you to experience true luxury amid nature, offering elegant accommodations and sweeping forest-views that blend comfort with tranquillity. Perched at the edge of lush greenery, the resort features open lawns that gaze into tree-lined vistas, chic cottages designed for relaxation, and event spaces framed by natural backdrops — making it ideal for both a lavish stay and a serene escape. Whether you’re seeking a peaceful weekend getaway, a family retreat or an upscale gathering, Woodland Escape Resort delivers refined hospitality, gourmet dining, and forest-front ambiance that elevate the stay into a memorable experience.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Luxury Resort in Nagpur District with Forest View",
      "description": "Experience unmatched luxury in Nagpur district with resorts offering stunning forest views, elegant accommodations, and serene surroundings. Perfect for nature lovers and those seeking a peaceful getaway, these resorts combine modern amenities with the tranquility of the jungle."
    },
    {
      "name": "Nagpur Forest View Resort",
      "description": "Stay at Nagpur resorts overlooking lush forests, with panoramic vistas, luxurious rooms, and private balconies. Ideal for couples, families, or solo travelers seeking a peaceful retreat close to nature."
    },
    {
      "name": "Nagpur Luxury Nature Resort",
      "description": "Immerse yourself in nature at Nagpur luxury resorts featuring landscaped gardens, walking trails, and scenic viewpoints. Enjoy a blend of comfort, privacy, and natural beauty for a rejuvenating stay."
    },
    {
      "name": "Nagpur Premium Resort in Forest",
      "description": "Indulge in premium amenities at Nagpur forest resorts with exclusive villas, private pools, and lush greenery. Perfect for travelers looking for a lavish escape surrounded by untouched forest landscapes."
    },
    {
      "name": "Nagpur Weekend Luxury Resort",
      "description": "Plan a relaxing weekend stay at Nagpur luxury resorts with forest views, offering recreational activities, fine dining, and spa facilities. Ideal for unwinding and reconnecting with nature over a short getaway."
    },
    {
      "name": "Nagpur Hill Forest Resort",
      "description": "Experience hilltop luxury at Nagpur resorts nestled in forests, offering panoramic views, cool breezes, and private spaces. Perfect for a romantic or family retreat with a blend of adventure and relaxation."
    },
    {
      "name": "Nagpur Eco Luxury Resort",
      "description": "Stay in eco-friendly luxury resorts in Nagpur, combining sustainability with modern comforts. Enjoy green architecture, organic dining options, and immersive forest experiences without compromising on luxury."
    },
    {
      "name": "Nagpur Private Luxury Resort",
      "description": "Opt for private luxury resorts in Nagpur offering secluded villas, exclusive amenities, and intimate forest surroundings. Ideal for honeymooners, couples, or anyone seeking privacy and comfort amidst nature."
    },
    {
      "name": "Nagpur Family Luxury Resort",
      "description": "Bring the whole family to Nagpur luxury resorts with forest views, featuring family-friendly activities, spacious accommodations, and safe outdoor areas. Enjoy a relaxing and adventurous stay for all ages."
    },
    {
      "name": "Nagpur Couple Luxury Resort",
      "description": "Perfect for couples, these Nagpur resorts offer romantic forest-view settings, cozy rooms, candlelight dinners, and scenic walking trails. A luxurious and intimate retreat for love and relaxation."
    },
    {
      "name": "Nagpur Riverside Luxury Resort",
      "description": "Enjoy a luxury stay by the river in Nagpur resorts with forest views, combining serene waterscapes with top-notch amenities. Ideal for a peaceful, scenic, and rejuvenating experience."
    },
    {
      "name": "Nagpur Booking Luxury Forest Resort",
      "description": "Easily book your luxury forest resort in Nagpur online with options for premium rooms, private villas, and curated packages. Ensures a hassle-free planning experience for your forest escape."
    },
    {
      "name": "Nagpur Scenic Luxury Resort",
      "description": "Immerse yourself in scenic beauty at Nagpur luxury resorts offering breathtaking views, manicured gardens, and scenic viewpoints. Perfect for photography enthusiasts and nature lovers."
    },
    {
      "name": "Nagpur Luxury Stay in Jungle",
      "description": "Experience jungle luxury in Nagpur with resorts offering exclusive stays amidst wildlife, nature trails, and serene forest landscapes. Ideal for adventurous travelers who value comfort and style."
    },
    {
      "name": "Nagpur Luxury Nature Stay",
      "description": "Combine luxury with nature at Nagpur resorts offering forest stays, modern amenities, and eco-friendly experiences. Perfect for travelers seeking tranquility, privacy, and rejuvenation."
    }
  ],
  "tableData": [
    ["- Luxury Resort in Nagpur District with Forest View", "- Nagpur Forest View Resort"],
    ["- Nagpur Luxury Nature Resort", "- Nagpur Premium Resort in Forest"],
    ["- Nagpur Weekend Luxury Resort", "- Nagpur Hill Forest Resort"],
    ["- Nagpur Eco Luxury Resort", "- Nagpur Private Luxury Resort"],
    ["- Nagpur Family Luxury Resort", "- Nagpur Couple Luxury Resort"],
    ["- Nagpur Riverside Luxury Resort", "- Nagpur Booking Luxury Forest Resort"],
    ["- Nagpur Scenic Luxury Resort", "- Nagpur Luxury Stay in Jungle"],
    ["- Nagpur Luxury Nature Stay", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Luxury Forest‑View Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a premium holiday experience in Nagpur district where you stay surrounded by nature’s beauty. With luxury accommodation, scenic forest views and thoughtful amenities, it’s the ideal pick for those seeking comfort, tranquility and an immersive escape into nature."
  },
  {
    "WhyChooseheading": "Rooms with Scenic Forest Panorama",
    "WhyChoosedescription": "Each stay at Woodland Escape Resort is designed to bring the forest to your window. Whether you select a deluxe room or a suite, you’ll wake up to views of tree‑lined grounds, dappled sunlight and maybe even the gentle rustle of leaves — bringing a feeling of being right within the forest canopy."
  },
  {
    "WhyChoosedescription": "Surrounded by lush greenery and mature trees, Woodland Escape Resort’s grounds offer a calm and refreshing ambience. Meander along shaded walkways, lounge in quiet sit‑outs under the foliage, and breathe in the natural calm — perfect for recovery, reflection and reconnecting with nature.",
    "WhyChooseheading": "Tranquil Natural Setting"
  },
  {
    "WhyChooseheading": "High‑End Comfort Meets Nature",
    "WhyChoosedescription": "The resort blends luxury touches with its forest surroundings: think air‑conditioned rooms, premium linens, modern bathrooms AND views of green‑draped surroundings. The result is specialty lodging where nature isn’t compromised for comfort — you get both."
  },
  {
    "WhyChooseheading": "Exclusive Activities Amidst the Trees",
    "WhyChoosedescription": "At Woodland Escape Resort you’re not just staying inside four walls — there are forest‑view spaces for relaxation, nature trails on the property, outdoor lounges and potentially private decks. It’s geared for guests who want more than just ‘a view’ but an experience of being in the woods."
  },
  {
    "WhyChooseheading": "Ideal for Special Occasions & Getaways",
    "WhyChoosedescription": "Whether it’s a romantic weekend, a family luxury break, or a small‑scale celebration, Woodland Escape Resort offers the right backdrop. With forest‑facing rooms, premium service and scenic setting, it elevates a simple stay into a memorable occasion."
  },
  {
    "WhyChooseheading": "Conveniently Located in Nagpur District",
    "WhyChoosedescription": "While giving you the feeling of being deep in nature, Woodland Escape Resort remains accessible from Nagpur city. This means you get the benefit of a remote‑forest retreat without the hassle of very long travel — ideal for a luxury stay or spontaneous weekend."
  }
]

























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a luxury resort with forest view in Nagpur district?",
    answer: "Woodland Escape Resort offers a premium stay experience in a tranquil natural setting. With scenic green surroundings and a serene forest-like ambiance, it is perfect for guests seeking luxury amidst nature."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is within comfortable driving distance from Nagpur city, making it easily accessible for day trips, weekend getaways, or extended stays while enjoying a forest-view environment."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for a luxury stay?",
    answer: "The resort provides spacious, well-furnished rooms, private balconies with scenic greenery views, outdoor lawns, children’s play areas, nature trails, and recreational activities designed for relaxation and enjoyment."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups seeking a forest-view luxury stay?",
    answer: "Absolutely! The resort is family-friendly and group-friendly, offering safe and comfortable spaces where all guests can enjoy nature, privacy, and luxury amenities."
  },
  {
    question: "Does the resort provide food and other services for luxury guests?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. Guests can enjoy tailored dining options and services that complement a luxurious stay in a forest-view setting."
  },
  {
    question: "How can we book Woodland Escape Resort for a luxury forest-view stay in Nagpur district?",
    answer: "Bookings can be made by calling or WhatsApp messaging the resort's reservations team, or through their official website. Advance booking is recommended, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Rajesh & Family, Nagpur",
    text: "Our stay at Woodland Escape Resort was unforgettable! The rooms overlooking lush greenery and the serene forest-like environment made it a perfect luxury retreat in Nagpur district."
  },
  {
    name: "Ms. Anjali & Friends, Nagpur",
    text: "Woodland Escape Resort exceeded our expectations. The luxury rooms, peaceful surroundings, and forest-view ambiance made our weekend getaway truly special. Highly recommended!"
  }
];






























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Resort in Nagpur District with Forest View",
  "image": "https://woodlandescape.com/assets/images/nagpur-luxury-forest-resort.jpg",
  "description": "Experience ultimate luxury at Woodlandescape Resort in Nagpur District with panoramic forest views. Perfect for family stays, couple retreats, weekend getaways, and nature-inspired luxury vacations.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "45"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-luxury-forest-resort"
  }
};




  return (
    <div>

<Helmet>
  <title>Luxury Resort in Nagpur District with Forest View | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Stay at Woodlandescape Resort in Nagpur District with luxury forest views. Ideal for family vacations, couple retreats, eco-friendly nature stays, riverside luxury, and scenic weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Luxury Resort in Nagpur District with Forest View, Nagpur Forest View Resort, Nagpur Luxury Nature Resort, Nagpur Premium Resort in Forest, Nagpur Weekend Luxury Resort, Nagpur Hill Forest Resort, Nagpur Eco Luxury Resort, Nagpur Private Luxury Resort, Nagpur Family Luxury Resort, Nagpur Couple Luxury Resort, Nagpur Riverside Luxury Resort, Nagpur Booking Luxury Forest Resort, Nagpur Scenic Luxury Resort, Nagpur Luxury Stay in Jungle, Nagpur Luxury Nature Stay" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/48.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Luxuryresortinnagpurdistricwihforestview;